export const DEVICE_GROUP_SEARCH = 'DEVICE_GROUP_SEARCH';
